import {
  Typography,
  OutlinedInput,
  Grid,
  Select,
  MenuItem,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { REFERRAL_LIST } from "../../utils/common/constants";
import { getValue } from "@testing-library/user-event/dist/utils";

const GuestAccountInformation = () => {
  const { control, setValue, watch, getValues } = useFormContext();
  const [isOtherReferralSource, setIsOtherReferralSource] = useState(false);
  useEffect(() => {
    if (getValues("ReferralSource")?.id === 8) {
      setIsOtherReferralSource(true);
    }
    else {
      setIsOtherReferralSource(false);
    }

  }, [getValues("ReferralSource")]);

  const renderDropDownField = (
    label: string,
    name: "ReferralSource",
    options: any[],
    defaultOption: any
  ) => (
    <>
      <Typography className="form-label" variant="h6" gutterBottom>
        {label}
      </Typography>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultOption}
        rules={name == "ReferralSource" ? {
          validate: (value) =>
            value?.value !== 0 || `Please select Referral Source`
        } : {}
        }
        render={({ field, fieldState: { error } }) => (
          <>
            <Select
              defaultValue={defaultOption}
              value={field.value?.value ?? ""}
              onChange={(e) => {
                const selected = options.find((o) => o.value === e.target.value);
                field.onChange(selected);
                if (e.target.value == REFERRAL_LIST[8].value) {
                  setIsOtherReferralSource(true);
                }
                else {
                  setIsOtherReferralSource(false);
                }
              }}
              fullWidth
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 250
                  }
                }
              }}
            >
              {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            {error && (
              <Typography
                className="error-text"
                color="error"
                fontSize="12px"
              >
                {error.message}
              </Typography>
            )}
          </>
        )}
      />
    </>
  );

  const renderInputField = (
    label: string,
    name: "AccountNumber" | "Other",
    placeholder: string
  ) => (
    <>
      <Typography className="form-label" variant="h6" gutterBottom>
        {label}
      </Typography>
      <Controller
        name={name}
        control={control}
        rules={name == "AccountNumber" ? {
          minLength: {
            value: 3,
            message: "Minimum 3 digits required"
          },
          maxLength: {
            value: 10,
            message: "Maximum 10 digits allowed"
          }
        } : name === "Other" ? {
          required: "Please enter Other referral source"
        } : {}}
        render={({ field, fieldState: { error } }) => (
          <>
            <OutlinedInput
              {...field}
              placeholder={placeholder}
              fullWidth
              autoComplete="off"
              value={field.value || ""}
              onChange={
                (e) => {
                  if (field.name == "AccountNumber") {
                    if (e.target.value.length <= 10) {
                      field.onChange(
                        e.target.value.replace(/\D/g, "").slice(0, 10) || ""
                      )
                    }
                  }
                  else {
                    field.onChange(
                      e.target.value || ""
                    )
                  }
                }}
              sx={{ height: "40px", fontSize: "14px", borderColor: error ? "red" : undefined }}
            />
            {error && (
              <Typography
                className="error-text"
                color="error"
                fontSize="12px"
              >
                {error.message}
              </Typography>
            )}
          </>
        )}
      />
    </>
  );

  return (
    <>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          {renderInputField("ADL Account# (Optional)", "AccountNumber", "Enter ADL Account#")}
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          {renderDropDownField(
            "Referral Source*",
            "ReferralSource",
            REFERRAL_LIST,
            REFERRAL_LIST[0]
          )}
        </Grid>
        {
          isOtherReferralSource &&
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            {renderInputField("Other*", "Other", "Enter other referral source")}
          </Grid>
        }

      </Grid>

    </>
  );
};

export default GuestAccountInformation;
